(function () {
  function updateProductShippingNotes() {
    var notes = document.querySelectorAll('.product-shipping-note[data-free-min]');
    if (!notes.length) return;

    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        notes.forEach((note) => {
          var freeMin = parseInt(note.dataset.freeMin, 10);
          if (isNaN(freeMin)) return;

          var isActive = cart.total_price >= freeMin;
          var textEl = note.querySelector('.product-shipping-note__text');
          var liveEl = note.querySelector('.product-shipping-note__live');

          note.classList.toggle('product-shipping-note--active', isActive);

          if (isActive) {
            if (textEl) textEl.textContent = 'Envío gratis activo';
            if (!liveEl) {
              liveEl = document.createElement('span');
              liveEl.className = 'product-shipping-note__live';
              liveEl.setAttribute('aria-hidden', 'true');
              note.appendChild(liveEl);
            }
          } else {
            if (liveEl) liveEl.remove();
            if (textEl) {
              // formatMoney() returns the shop's configured money_format, which can include
              // its own HTML (e.g. <span class="money">); innerHTML renders it correctly.
              textEl.innerHTML =
                'Te faltan ' + formatMoney(freeMin - cart.total_price) + ' para el envío gratis';
            }
          }
        });
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateProductShippingNotes();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, updateProductShippingNotes);
    }
  });

  document.addEventListener('shopify:section:load', updateProductShippingNotes);
})();
